import { PUBLIC_CHATRA_ENABLED } from "$env/static/public";
import { isTruthy } from "$utils/boolean.utils";

export const cTypes = {
    NECESSARY: {
        id: "ncs",
        name: "Absolut nödvändiga cookies",
        editable: false,
        description: `Dessa cookies är nödvändiga för att webbplatsen ska fungera och kan inte
    stängas av i våra system. De är vanligtvis bara inställda som svar på
    åtgärder som du gjort som utgör en begäran om tjänster, till exempel
    inställning av dina personliga preferenser, kundvagnen eller kassan. Dessa
    cookies lagrar inte någon personligt identifierbar information.`,
        cookies: [
            { name: "ns-cart", provider: "1:a part", ttl: "Permanent", description: "Kundvagnen i webbutiken" },
            {
                name: "_klarna_sdid_ch",
                provider: "1:a part",
                ttl: "Permanent",
                description: "Unika id:n som skapas och används vid betalningar",
            },
            {
                name: "test_cookie",
                provider: "1:a part",
                ttl: "1 dag",
                description: "Används av Google Analytics för att se om webbläsaren stödjer cookies.",
            },
        ],
    },
    PERFORMANCE: {
        id: "pfm",
        name: "Prestanda-cookies",
        editable: true,
        description: `Dessa cookies tillåter oss att räkna besök och trafikkällor så att vi kan
    mäta och förbättra prestandan på vår webbplats. De hjälper oss att veta
    vilka sidor som är mest och minst populära och se hur besökare flyttar runt
    på webbplatsen. All information som dessa cookies samlar är aggregerade och
    därför anonyma. Om du inte tillåter dessa cookies vet vi inte när du har
    besökt vår webbplats.`,
        cookies: [
            {
                name: "_ga",
                provider: "1:a part",
                ttl: "2 år",
                description:
                    "Registrerar ett unikt id för varje användare för att kunna samla in statistik om användningen av siten.",
            },
            {
                name: "_ga_#",
                provider: "1:a part",
                ttl: "2 år",
                description: "Används av Google Analytics för att samla in när ett visst id besökt siten.",
            },
            {
                name: "_gat",
                provider: "1:a part",
                ttl: "1 dag",
                description: "Används av Google Analytics för att se till så att statistik inte lagras för ofta.",
            },
            {
                name: "_gid",
                provider: "1:a part",
                ttl: "1 dag",
                description:
                    "Registrerar ett unikt id för varje avnändare för att kunna lagra statistik om hur användaren använder siten.",
            },
            {
                name: "_gcl_au",
                provider: "1:a part",
                ttl: "3 månader",
                description: "Används av Google AdSense för att kunna anpassa anonnsvisningar.",
            },
            {
                name: "IDE",
                provider: "3:e part",
                ttl: "1 år",
                description:
                    "Används av Google DoubleClick för att hjälpa site-ägaren att få insyn i hur siten används.",
            },
            {
                name: "_uet*",
                provider: "1:a part",
                ttl: "1 år",
                description:
                    "Används av Bing för att spåra besökare på webbplatser som använder Bing annonseringstjänster.",
            },
            {
                name: "_fpc",
                provider: "1:a part",
                ttl: "3 månader",
                description:
                    "Används av Meta för att spåra besökare på webbplatser som använder Meta annonseringstjänster.",
            },
        ],
    },
};

if (isTruthy(PUBLIC_CHATRA_ENABLED)) {
    cTypes.PERFORMANCE.cookies.push({
        name: "Chatra.#",
        provider: "3:e part",
        ttl: "Permanent",
        description: "Används av chatttjänsten som kundtjänst använder för att hjälpa kunder via webbsidan.",
    });
}
